
export interface Translatable {
    readonly translationKey: string;
    readonly translationDefault: string;
};
export type UnknownTranslationCollection = {
    [key: string]: {
        defaultValue: string;
        reported: boolean;
    };
};
type TranslationArgs = { [argName: string]: string };

type TranslatableTranslator = (key: string, defaultValue: string, args?: TranslationArgs) => string;
type StringTranslator = (o: Translatable, args?: TranslationArgs) => string;
export type Translator = TranslatableTranslator & StringTranslator;

function fillTemplate(template: string, args: { [argName: string]: string }): string {
    let result = template;
    for (let key in args) {
        result = result.replaceAll("{" + key + "}", args[key]);
    }
    return result;
}

export class TranslationService {

    constructor(
        private readonly translations: { [key: string]: string | undefined } | undefined,
        private readonly showTranslationKeys: boolean
    ) {

    }

    static unknownTranslations: UnknownTranslationCollection = {};

    translate(translatable: Translatable, args?: TranslationArgs): string;
    translate(key: string, defaultValue: string, args?: TranslationArgs): string;
    translate(a: string | Translatable, b: string | TranslationArgs | undefined, c?: TranslationArgs): string {

        let key;
        let defaultValue;
        let args;
        if (typeof a === "string") {
            key = a;
            defaultValue = b as string;
            args = c as TranslationArgs | undefined;
        }
        else {
            key = a.translationKey;
            defaultValue = a.translationDefault;
            args = b as TranslationArgs | undefined;
        }
        if (!args) {
            args = {} as TranslationArgs;
        }

        let result = this.getValue(key, defaultValue);
        result = fillTemplate(result, args);
        return result;
    }

    private getValue(key: string, defaultValue: string) {
        key = key.toLowerCase();
        if (this.showTranslationKeys) {
            return "<" + key + ">";
        }
        if (this.translations) {
            let result = this.translations[key];
            if (result)
                return result;

            this.reportMissing(key, defaultValue);
            this.translations[key] = defaultValue;
            return defaultValue;
        }
        return defaultValue;
    }

    private reportMissing(key: string, defaultValue: string) {
        const existingReport = TranslationService.unknownTranslations[key];
        if (existingReport)
            return;
        TranslationService.unknownTranslations[key] = {
            defaultValue,
            reported: false,
        };
    }

}

let numTranslations = 0;

const NullTranslator: Translator = (a: string | Translatable, b?: string | TranslationArgs, c?: TranslationArgs) => {
    let defaultValue;
    let args;
    if (typeof a === "string") {
        defaultValue = b as string;
        args = c as TranslationArgs | undefined;
    }
    else {
        defaultValue = a.translationDefault;
        args = b as TranslationArgs | undefined;
    }
    if (!args) {
        args = {} as TranslationArgs;
    }

    if (++numTranslations % 100 === 1) {
        console.log("Using NullTranslator");
    }
    return fillTemplate(defaultValue, args);
}

export { NullTranslator }
